import React, { useState, ChangeEvent } from 'react';
import { Modal } from 'react-bootstrap';

import SVButton from 'components/elements/SVButton';
import { getProgramTypeFromApplicationType } from 'utils/enums';

interface PRQSubmitConfirmationProps {
  onSubmit: () => void;
  onCancel: () => void;
  applicationType: string;
}

const PRQSubmitConfirmation: React.FC<PRQSubmitConfirmationProps> = ({
  onSubmit,
  onCancel,
  applicationType,
}) => {
  const [medical, setMedical] = useState(false);
  const [satisfied, setSatisfied] = useState<boolean | null>(null);

  const canSubmit = medical && satisfied;

  return (
    <Modal show onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Final Submit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure your form is complete and you are ready to submit the
          form for review? This cannot be undone.
        </p>
        <p>
          <input
            type="checkbox"
            style={{ marginRight: '1rem' }}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setMedical(e.target.checked)}
          />
          {'A '}
          {getProgramTypeFromApplicationType(applicationType) === 'Fellowship' ? 'Fellowship' : 'Medical'}
          {' Director has signed-off on the answers given in this form'}
        </p>
        <p>
          <input
            type="checkbox"
            style={{ marginRight: '1rem' }}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setSatisfied(e.target.checked)}
          />
          I am satisfied with the answers given in this form and wish to submit
          for review
        </p>
      </Modal.Body>
      <Modal.Footer>
        <SVButton size="sm" variant="cancel" onClick={onCancel}>
          Cancel
        </SVButton>
        <SVButton
          size="sm"
          variant="secondary"
          onClick={onSubmit}
          disabled={!canSubmit}
        >
          Submit
        </SVButton>
      </Modal.Footer>
    </Modal>
  );
};

export default PRQSubmitConfirmation;
